/** @jsxImportSource @emotion/react */

export type SelectFilterValue = string | null;
export type SelectFilterOption = { value: string; label: string };

export const defaultSelect: SelectFilterValue = null;

export type SelectFilterProps = {
  value: SelectFilterValue | null;
  options?: SelectFilterOption[];
  onChange(value: SelectFilterValue): void;
};

export function SelectFilter({ onChange, ...props }: SelectFilterProps) {
  const value = props.value ?? defaultSelect;
  const options = props.options ?? [];

  return (
    <>
      <div className="lp-w-full mb-16">
        <div className="selectdropdown">
          <select
            className="form-control"
            value={value ?? ''}
            onChange={({ target: { value: option } }) => {
              onChange(option as SelectFilterValue);
            }}
            data-testid="select-filter-type-select"
          >
            <option value="">-- Select an option --</option>
            {options.map((option) => (
              <option value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}
